module.exports = __webpack_public_path__ + "media/images/lb/780-7074f0afbaab66d8d55dcf4b0d4c5264.svg";